<template>
    <div id="concierge-services-page" class="margin-top-100">

        <!-- Content Section -->
        <section class="section-style">
            <div class="container padding-right-left-0">
                <div class="row">
                    <div class="col">
                        <p>
                            Due to strict Insurance Policy procedures, the allowed time to include Ultimate Travel Protection Insurance to this booking has expired.
                        </p>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        }
    }
</script>

<style lang="scss">

</style>
